import type { GetServerSideProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

import { NewsPage } from '@/components/pages/news/NewsPage';
import { Meta } from '@/layouts/Meta';
import { client } from '@/libs/client';
import { Main } from '@/templates/Main';

export type NewsCategory = {
  id: string;
  name: string;
};

export type News = {
  id: string;
  title: string;
  content: string;
  category?: NewsCategory;
  publishedAt: string;
  createdAt: string;
};

export type Props = {
  newsList: News[];
  page: {
    current: number;
    last: number;
  };
};

const Index = (props: Props) => {
  return (
    <Main
      meta={
        <Meta
          title="お知らせ｜税理士法人奏共同会計事務所"
          description="税理士法人奏共同会計事務所は、資本戦略の実行支援を専門とする日本唯一の税理士法人です。組織再編、事業承継、M&A、国際資本戦略など、企業の成長ステージに応じた先進的なソリューションを提供。高い職業倫理と専門性を持つプロフェッショナル集団として、お客様の経営課題解決を支援します。"
          image="/ogp-images/ogp.jpg"
        />
      }
      autoHeight
      offsetTop={0}
      desktop={<NewsPage {...props} />}
      // レスポンシブデザインなので desktop と同じコンポーネントを渡している
      mobile={<NewsPage {...props} />}
    />
  );
};

export const getServerSideProps: GetServerSideProps<Props> = async ({
  locale,
  query,
}) => {
  const currentPage =
    typeof query.page === 'string' ? parseInt(query.page, 10) : 1; // デフォルトは1ページ目
  const limit = 10; // 1ページあたりの記事数

  try {
    const newsRes = await client.getList<News>({
      endpoint: 'news',
      queries: {
        offset: (currentPage - 1) * limit,
        limit,
      },
    });

    return {
      props: {
        newsList: newsRes.contents,
        page: {
          current: currentPage,
          last: Math.ceil(newsRes.totalCount / limit),
        },
        ...(await serverSideTranslations(locale!, ['common', 'news'])),
      },
    };
  } catch (error) {
    // API エラー時は空のリストを返す
    return {
      props: {
        newsList: [],
        page: {
          current: 1,
          last: 1,
        },
        ...(await serverSideTranslations(locale!, ['common', 'news'])),
      },
    };
  }
};

export default Index;
